import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class HorizontalStick extends Component {

  static propTypes = {
    isEven: PropTypes.bool,
    value: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
    width: PropTypes.number
  }

  static defaultProps = {
    isEven: false,
    value: 0,
    width: 0
  }

  state = {
    animate: true
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      /* eslint-disable react/no-did-update-set-state */
      this.setState({
        animate: true
      }, () => setTimeout(() => {
        this.setState({
          animate: false
        })
      }, 500))
      /* eslint-enable */
    }
  }

  render() {
    const { width, value, isEven } = this.props
    const isLow = width < 3 ? 'horizontal-stick__row--low' : '';
    const gradientColor = isEven ? 'horizontal-stick__row--teal' : 'horizontal-stick__row--green';
    const isLabelSmall = isEven ? '' : 'horizontal-stick__value--small';

    return (
      <div className="horizontal-stick">
        <div className={`horizontal-stick__row ${isLow} ${gradientColor} ${this.state.animate ? 'animate': ''}`} style={{ width: `${width}%` }} />
        <span className={`horizontal-stick__value ${isLabelSmall}`}>{value}</span>
      </div>
    )
  }
}
